// extracted by mini-css-extract-plugin
export default {"card":"c5-z"};